export type AppLanguage = 'bn' | 'en';

export const LANGUAGE_STORAGE_KEY = 'htally_language';

export const MONTH_TRANSLATION_KEYS = [
  'month.january',
  'month.february',
  'month.march',
  'month.april',
  'month.may',
  'month.june',
  'month.july',
  'month.august',
  'month.september',
  'month.october',
  'month.november',
  'month.december'
] as const;

export const SHORT_MONTH_TRANSLATION_KEYS = [
  'monthShort.january',
  'monthShort.february',
  'monthShort.march',
  'monthShort.april',
  'monthShort.may',
  'monthShort.june',
  'monthShort.july',
  'monthShort.august',
  'monthShort.september',
  'monthShort.october',
  'monthShort.november',
  'monthShort.december'
] as const;

export const APP_TRANSLATIONS: Record<AppLanguage, Record<string, string>> = {
  bn: {
    'language.bn': 'বাংলা',
    'language.en': 'English',
    'language.bnShort': 'বা',
    'language.enShort': 'EN',

    'menu.DASHBOARD': 'ড্যাশবোর্ড',
    'menu.PAYMENT_LIST': 'লেনদেন',
    'menu.RENTER_LIST': 'ভাড়াটিয়া',
    'menu.HOUSE_LIST': 'বাড়ি',
    'menu.USER_LIST': 'অন্যান্য',
    'menu.HELP_USER_MANUAL': 'হেল্প',

    'nav.signUp': 'সাইন আপ',
    'nav.signIn': 'সাইন ইন',
    'nav.openMenu': 'মেনু খুলুন',
    'nav.expandSidebar': 'মেনু বড় করুন',
    'nav.collapseSidebar': 'মেনু ছোট করুন',

    'common.filter': 'ফিল্টার',
    'common.apply': 'প্রয়োগ করুন',
    'common.reset': 'রিসেট',
    'common.data': 'তথ্য',
    'common.showDeletedData': 'ডিলিট করা তথ্য দেখান',
    'common.startDate': 'শুরুর তারিখ',
    'common.endDate': 'শেষের তারিখ',
    'common.option': 'অপশন',
    'common.clearSelection': 'নির্বাচন মুছুন',
    'common.noOptionFound': 'কোনো অপশন পাওয়া যায়নি',
    'common.loading': 'লোড হচ্ছে...',
    'common.dropdownConfigRequired': 'ড্রপডাউন সেটআপ প্রয়োজন।',
    'common.invalidDropdownApiInfo': 'ড্রপডাউন API তথ্য সঠিক নয়।',
    'common.unableToLoadDropdownOptions': 'ড্রপডাউন তথ্য লোড করা যায়নি।',
    'common.user': 'ব্যবহারকারী',
    'common.na': 'প্রযোজ্য নয়',
    'common.close': 'বন্ধ করুন',
    'common.search': 'খুঁজুন',
    'common.download': 'ডাউনলোড',
    'common.show': 'দেখান',
    'common.hide': 'লুকান',
    'common.limit': 'লিমিট',
    'common.storage': 'ফাইল স্টোরেজ',
    'common.used': 'ব্যবহার হয়েছে',
    'common.copy': 'কপি',
    'common.copied': 'কপি হয়েছে',
    'common.active': 'সক্রিয়',
    'common.inactive': 'নিষ্ক্রিয়',
    'common.saving': 'সেভ হচ্ছে...',
    'common.updating': 'আপডেট হচ্ছে...',
    'common.uploading': 'আপলোড হচ্ছে...',
    'common.uploadingAction': 'আপলোড',
    'common.selectFile': 'ফাইল নির্বাচন করুন',
    'common.remove': 'মুছুন',
    'common.preview': 'প্রিভিউ',
    'common.changeLogo': 'লোগো পরিবর্তন করুন',
    'common.done': 'সম্পন্ন',
    'common.skip': 'এড়িয়ে যান',
    'common.skipForNow': 'আপাতত এড়িয়ে যান',
    'common.next': 'পরের ধাপ',

    'page.dashboard': 'ড্যাশবোর্ড',
    'page.transaction': 'লেনদেন',
    'page.expense': 'খরচ',
    'page.renter': 'ভাড়াটিয়া',
    'page.house': 'বাড়ি',
    'page.deleted': 'ডিলিট করা তথ্য',
    'page.user': 'ব্যবহারকারী',
    'page.activity': 'অ্যাকটিভিটি',
    'page.other': 'অন্যান্য',
    'page.subscription': 'সাবস্ক্রিপশন',
    'page.helpUserManual': 'হেল্প',

    'help.userManualTab': 'ইউজার ম্যানুয়াল',
    'help.videoTutorialsTab': 'ভিডিও টিউটোরিয়াল',
    'help.faqTab': 'FAQ',
    'help.comingSoon': 'Comming soon',

    'month.january': 'জানুয়ারি',
    'month.february': 'ফেব্রুয়ারি',
    'month.march': 'মার্চ',
    'month.april': 'এপ্রিল',
    'month.may': 'মে',
    'month.june': 'জুন',
    'month.july': 'জুলাই',
    'month.august': 'আগস্ট',
    'month.september': 'সেপ্টেম্বর',
    'month.october': 'অক্টোবর',
    'month.november': 'নভেম্বর',
    'month.december': 'ডিসেম্বর',
    'monthShort.january': 'জানু',
    'monthShort.february': 'ফেব',
    'monthShort.march': 'মার্চ',
    'monthShort.april': 'এপ্রি',
    'monthShort.may': 'মে',
    'monthShort.june': 'জুন',
    'monthShort.july': 'জুলাই',
    'monthShort.august': 'আগ',
    'monthShort.september': 'সেপ্টে',
    'monthShort.october': 'অক্টো',
    'monthShort.november': 'নভে',
    'monthShort.december': 'ডিসে',

    'paymentMethod.cash': 'ক্যাশ',
    'paymentMethod.bank': 'ব্যাংক',
    'paymentMethod.cheque': 'চেক',
    'paymentMethod.mobileBanking': 'মোবাইল ব্যাংকিং',
    'paymentMethod.adjustFromAdvance': 'অ্যাডভান্স থেকে সমন্বয়',
    'paymentMethod.other': 'অন্যান্য',

    'filter.house': 'বাড়ি',
    'filter.flat': 'ফ্ল্যাট',
    'filter.renter': 'ভাড়াটিয়া',
    'filter.transactionNo': 'ট্রানজ্যাকশন নং',
    'filter.paymentYear': 'পেমেন্ট বছর',
    'filter.paymentMonth': 'পেমেন্ট মাস',
    'filter.paymentMethod': 'পেমেন্ট পদ্ধতি',
    'filter.paymentDateRange': 'পেমেন্ট তারিখ',
    'filter.createdOnRange': 'তৈরির তারিখ',
    'filter.expenseHead': 'খরচের খাত',
    'filter.expenseYear': 'খরচের বছর',
    'filter.expenseMonth': 'খরচের মাস',
    'filter.expenseDateRange': 'খরচের তারিখ',
    'filter.renterName': 'ভাড়াটিয়ার নাম',
    'filter.mobile': 'মোবাইল',
    'filter.email': 'ইমেইল',
'filter.photoId': 'এনআইডি/জন্ম নিবন্ধন নং',
    'filter.renterMobile': 'ভাড়াটিয়ার মোবাইল',
    'filter.flatName': 'ফ্ল্যাটের নাম',
    'filter.houseName': 'বাড়ির নাম',
    'filter.address': 'ঠিকানা',
    'filter.floor': 'ফ্লোর',
    'filter.employeeName': 'সাবইউজারের নাম',

    'placeholder.selectHouse': 'বাড়ি নির্বাচন করুন',
    'placeholder.selectFlat': 'ফ্ল্যাট নির্বাচন করুন',
    'placeholder.selectRenter': 'ভাড়াটিয়া নির্বাচন করুন',
    'placeholder.selectUser': 'ইউজার নির্বাচন করুন',
    'placeholder.selectPackage': 'প্যাকেজ নির্বাচন করুন',
    'placeholder.selectDuration': 'মেয়াদ নির্বাচন করুন',
    'placeholder.selectYear': 'বছর নির্বাচন করুন',
    'placeholder.selectMonth': 'মাস নির্বাচন করুন',
    'placeholder.selectExpenseHead': 'খরচের খাত নির্বাচন করুন',
    'placeholder.selectFloor': 'ফ্লোর নির্বাচন করুন',
    'placeholder.selectDate': 'তারিখ নির্বাচন করুন',
    'placeholder.selectEndDateOptional': 'শেষ তারিখ নির্বাচন করুন (ঐচ্ছিক)',
    'placeholder.typeTransactionNo': 'ট্রানজ্যাকশন নম্বর লিখুন',
    'placeholder.typeRenterName': 'ভাড়াটিয়ার নাম লিখুন',
    'placeholder.typeMobileNumber': 'মোবাইল নম্বর লিখুন',
    'placeholder.typeRenterMobile': 'ভাড়াটিয়ার মোবাইল লিখুন',
    'placeholder.typeEmail': 'ইমেইল লিখুন',
'placeholder.typePhotoId': 'এনআইডি/জন্ম নিবন্ধন নং লিখুন',
    'placeholder.typeFlatName': 'ফ্ল্যাটের নাম লিখুন',
    'placeholder.typeHouseName': 'বাড়ির নাম লিখুন',
    'placeholder.typeAddress': 'ঠিকানা লিখুন',
    'placeholder.typeEmployeeName': 'সাবইউজারের নাম লিখুন',
    'placeholder.typeEmployeeEmail': 'সাবইউজারের ইমেইল লিখুন',
    'placeholder.typeRenterEmail': 'ভাড়াটিয়ার ইমেইল লিখুন',
'placeholder.typePhotoIdNumber': 'এনআইডি/জন্ম নিবন্ধন নং লিখুন',
    'placeholder.typePermanentAddress': 'স্থায়ী ঠিকানা লিখুন',
    'placeholder.typePreviousAddress': 'পূর্বের ঠিকানা লিখুন',
    'placeholder.typeAdvanceAmount': 'অ্যাডভান্সের পরিমাণ লিখুন',
    'placeholder.typeAmount': 'পরিমাণ লিখুন',
    'placeholder.typeRemarksOptional': 'মন্তব্য লিখুন (ঐচ্ছিক)',
    'placeholder.typeFullName': 'পূর্ণ নাম লিখুন',
    'placeholder.typeOrganizationName': 'প্রতিষ্ঠান/বাড়ির নাম লিখুন',
    'placeholder.typeCurrentPassword': 'বর্তমান পাসওয়ার্ড লিখুন',
    'placeholder.typeNewPassword': 'নতুন পাসওয়ার্ড লিখুন',
    'placeholder.retypeNewPassword': 'পাসওয়ার্ড আবার লিখুন',
    'placeholder.typeNewEmail': 'নতুন ইমেইল লিখুন',
    'placeholder.typeOtp': 'ওটিপি লিখুন',
    'placeholder.typeOtpFromNewEmail': 'নতুন ইমেইল থেকে ওটিপি লিখুন',
    'placeholder.autoFromSelectedFlat': 'নির্বাচিত ফ্ল্যাট থেকে স্বয়ংক্রিয়ভাবে আসবে',
    'placeholder.typeFlatRentAmount': 'ফ্ল্যাট ভাড়ার পরিমাণ লিখুন',
    'placeholder.typeNegativeChargeName': 'নেগেটিভ চার্জের নাম লিখুন',
    'placeholder.typeFullAddress': 'পূর্ণ ঠিকানা লিখুন',
    'placeholder.typeFloorName': 'ফ্লোরের নাম লিখুন',

    'topHeader.pageInfo': 'পেইজ তথ্য',
    'topHeader.month': 'মাস',
    'topHeader.year': 'বছর',
    'topHeader.apply': 'প্রয়োগ করুন',
    'topHeader.editImage': 'ছবি পরিবর্তন',
    'topHeader.editProfile': 'প্রোফাইল সম্পাদনা',
    'topHeader.updatePassword': 'পাসওয়ার্ড আপডেট',
    'topHeader.logout': 'লগআউট',
    'topHeader.updateOrganizationLogo': 'প্রতিষ্ঠানের লোগো আপডেট',
    'topHeader.chooseImage': 'ছবি নির্বাচন করুন',
    'topHeader.allowed': 'অনুমোদিত',
    'topHeader.maxSize': 'সর্বোচ্চ সাইজ',
    'topHeader.updateProfile': 'প্রোফাইল আপডেট',
    'topHeader.basic': 'মূল তথ্য',
    'topHeader.fullName': 'পূর্ণ নাম',
    'topHeader.organizationName': 'প্রতিষ্ঠান/বাড়ির নাম',
    'topHeader.mobileNumber': 'মোবাইল নম্বর',
    'topHeader.saveBasicInfo': 'মূল তথ্য সেভ করুন',
    'topHeader.password': 'পাসওয়ার্ড',
    'topHeader.currentPassword': 'বর্তমান পাসওয়ার্ড',
    'topHeader.newPassword': 'নতুন পাসওয়ার্ড',
    'topHeader.retypeNewPassword': 'নতুন পাসওয়ার্ড আবার লিখুন',
    'topHeader.updatePasswordButton': 'পাসওয়ার্ড আপডেট করুন',
    'topHeader.email': 'ইমেইল',
    'topHeader.newEmail': 'নতুন ইমেইল',
    'topHeader.sendOtp': 'ওটিপি পাঠান',
    'topHeader.resendOtp': 'ওটিপি আবার পাঠান',
    'topHeader.otp': 'ওটিপি',
    'topHeader.otpExpiresIn': 'ওটিপির সময় বাকি',
    'topHeader.otpExpired': 'ওটিপির সময় শেষ। আবার পাঠান।',
    'topHeader.updateEmail': 'ইমেইল আপডেট করুন',

    'transaction.paymentTab': 'পেমেন্ট',
    'transaction.expenseTab': 'খরচ',
    'transaction.addPayment': 'পেমেন্ট যোগ করুন',
    'transaction.addExpense': 'খরচ যোগ করুন',
    'transaction.paymentCreateBlockedExpired': 'পেমেন্ট তৈরি করতে প্যাকেজ নবায়ন করুন।',
    'transaction.expenseCreateBlockedExpired': 'খরচ তৈরি করতে প্যাকেজ নবায়ন করুন।',

    'renter.renterTab': 'ভাড়াটিয়া',
    'renter.assignFlatTab': 'ফ্ল্যাট বরাদ্দ',
    'renter.addRenter': 'ভাড়াটিয়া যোগ করুন',
    'renter.assignFlat': 'ফ্ল্যাট বরাদ্দ করুন',
    'renter.postCreatePromptTitle': 'এই ভাড়াটিয়ার জন্য ফ্ল্যাট বরাদ্দ করবেন',
    'renter.postCreatePromptMessage': 'আপনি এখন একটি ফ্ল্যাট বরাদ্দ করতে পারেন অথবা পরের জন্য এটি এড়িয়ে যেতে পারেন।',
    'renter.imageUpdate': 'ভাড়াটিয়ার ছবি আপডেট',
    'renter.uploadModalEditTitle': 'ভাড়াটিয়ার ছবি সম্পাদনা',
    'renter.uploadModalCreateTitle': 'ভাড়াটিয়ার ছবি আপলোড',
    'renter.uploadHint': 'ঐচ্ছিক: আপনি এই ধাপটি এড়িয়ে গিয়ে পরে আপলোড করতে পারেন।',
    'renter.modalNewTitle': 'নতুন ভাড়াটিয়া',
    'renter.modalEditTitle': 'ভাড়াটিয়া সম্পাদনা',
    'renter.deleteTitle': 'ভাড়াটিয়া ডিলিট',
    'renter.deleteMessage': 'এই ভাড়াটিয়াকে ডিলিট করতে চান?',
    'renter.name': 'নাম',
    'renter.mobile': 'মোবাইল',
    'renter.email': 'ইমেইল',
'renter.photoIdNo': 'এনআইডি/জন্ম নিবন্ধন নং',
    'renter.permanentAddress': 'স্থায়ী ঠিকানা',
    'renter.previousAddress': 'পূর্বের ঠিকানা',
    'renter.addButton': 'ভাড়াটিয়া যোগ করুন',
    'renter.updateButton': 'ভাড়াটিয়া আপডেট করুন',
    'renter.detailsTitle': 'ভাড়াটিয়ার বিস্তারিত',
    'renter.renterInformation': 'ভাড়াটিয়ার তথ্য',
    'renter.homeInformation': 'বাসার তথ্য',
    'renter.agreementDocuments': 'চুক্তির কাগজপত্র',
    'renter.noAgreementDocument': 'কোনো চুক্তির কাগজ আপলোড করা হয়নি।',
    'renter.detailsFullTitle': 'ভাড়াটিয়ার পূর্ণ তথ্য',
    'renter.username': 'ইউজারনেম',
    'renter.startDate': 'শুরুর তারিখ',
    'renter.endDate': 'শেষ তারিখ',
    'renter.status': 'স্ট্যাটাস',
    'renter.advance': 'অ্যাডভান্স',
    'renter.used': 'ব্যবহৃত',
    'renter.remain': 'বাকি',
    'renter.loadingPaymentList': 'পেমেন্ট তালিকা লোড হচ্ছে...',
    'renter.noPaymentData': 'কোনো পেমেন্ট তথ্য পাওয়া যায়নি।',
    'renter.invalidYear': 'সঠিক বছর দিন (YYYY)।',
    'renter.failedToLoadDetails': 'ভাড়াটিয়ার বিস্তারিত লোড করা যায়নি।',
    'renter.failedToLoadPaymentList': 'ভাড়াটিয়ার পেমেন্ট তালিকা লোড করা যায়নি।',
    'renter.existingFile': 'আগের ফাইল',
    'renter.selectFile': 'ফাইল নির্বাচন করুন',
    'renter.fileSelectedSingular': 'ফাইল নির্বাচিত',
    'renter.fileSelectedPlural': 'ফাইল নির্বাচিত',
    'renter.noFileSelected': 'কোনো ফাইল নির্বাচিত হয়নি।',
    'renter.saveImage': 'ছবি সংরক্ষণ করুন',
    'renter.imageUpdatedSuccess': 'ভাড়াটিয়ার ছবি সফলভাবে আপডেট হয়েছে।',

    'assign.modalNewTitle': 'ফ্ল্যাট বরাদ্দ',
    'assign.modalEditTitle': 'ফ্ল্যাট বরাদ্দ সম্পাদনা',
    'assign.uploadModalEditTitle': 'চুক্তির কাগজ সম্পাদনা',
    'assign.uploadModalCreateTitle': 'চুক্তির কাগজ আপলোড',
    'assign.uploadHint': 'ঐচ্ছিক: আপনি এই ধাপটি এড়িয়ে গিয়ে পরে আপলোড করতে পারেন।',
    'assign.maxFiles': 'সর্বোচ্চ',
    'assign.files': 'ফাইল',
    'assign.existingFiles': 'আগের ফাইলসমূহ',
    'assign.selectFiles': 'ফাইল নির্বাচন করুন',
    'assign.filesSelected': 'ফাইল নির্বাচিত',
    'assign.noFilesSelected': 'কোনো ফাইল নির্বাচিত হয়নি।',
    'assign.saveDocuments': 'কাগজ সংরক্ষণ করুন',
    'assign.documentsUpdatedSuccess': 'চুক্তির কাগজ সফলভাবে আপডেট হয়েছে।',
    'assign.detailsTitle': 'ফ্ল্যাট বরাদ্দের বিস্তারিত',
    'assign.houseOptional': 'বাড়ি (ঐচ্ছিক)',
    'assign.floorOptional': 'ফ্লোর (ঐচ্ছিক)',
    'assign.flat': 'ফ্ল্যাট',
    'assign.renter': 'ভাড়াটিয়া',
    'assign.renterMobile': 'ভাড়াটিয়ার মোবাইল',
    'assign.renterStartDate': 'ভাড়াটিয়ার শুরুর তারিখ',
    'assign.renterEndDate': 'ভাড়াটিয়ার শেষ তারিখ',
    'assign.advanceAmount': 'অ্যাডভান্সের পরিমাণ',
    'assign.usedAdvance': 'ব্যবহৃত অ্যাডভান্স',
    'assign.remainingAdvance': 'অবশিষ্ট অ্যাডভান্স',
    'assign.createdOn': 'তৈরির সময়',
    'assign.endDateOptional': 'শেষ তারিখ (ঐচ্ছিক)',
    'assign.endDateHint': 'ভাড়াটিয়া ছাড়ানোর জন্য শেষ তারিখ দিন। সম্পাদনা মোডে এটি ঐচ্ছিক।',
    'assign.agreementDocumentUpdate': 'চুক্তিপত্র আপডেট',
    'assign.noDocumentUploaded': 'কোনো ডকুমেন্ট আপলোড করা হয়নি।',
    'assign.deleteTitle': 'বরাদ্দকৃত ফ্ল্যাট ডিলিট',
    'assign.deleteMessage': 'এই ফ্ল্যাট বরাদ্দটি ডিলিট করতে চান?',
    'assign.addButton': 'ফ্ল্যাট বরাদ্দ করুন',
    'assign.updateButton': 'বরাদ্দ আপডেট করুন',

    'house.houseTab': 'বাড়ি',
    'house.flatTab': 'ফ্ল্যাট',
    'house.addHouse': 'বাড়ি যোগ করুন',
    'house.addFlat': 'ফ্ল্যাট যোগ করুন',
    'house.postCreatePromptTitle': 'এই বাড়ির জন্য ফ্ল্যাট যোগ করবেন',
    'house.postCreatePromptMessage': 'আপনি এখন একটি ফ্ল্যাট যোগ করতে পারেন অথবা পরের জন্য এটি এড়িয়ে যেতে পারেন।',
    'house.modalNewTitle': 'নতুন বাড়ি',
    'house.modalEditTitle': 'বাড়ি সম্পাদনা',
    'house.deleteTitle': 'বাড়ি ডিলিট',
    'house.deleteMessage': 'এই বাড়িটি ডিলিট করতে চান?',
    'house.houseNameOrNumber': 'বাড়ির নাম / নম্বর',
    'house.address': 'ঠিকানা',
    'house.totalFloor': 'মোট ফ্লোর',
    'house.floor': 'ফ্লোর',
    'house.floorName': 'ফ্লোরের নাম',
    'house.addButton': 'বাড়ি যোগ করুন',
    'house.updateButton': 'বাড়ি আপডেট করুন',
    'house.floorUnit': 'টি ফ্লোর',

    'flat.modalNewTitle': 'নতুন ফ্ল্যাট',
    'flat.modalEditTitle': 'ফ্ল্যাট সম্পাদনা',
    'flat.deleteTitle': 'ফ্ল্যাট ডিলিট',
    'flat.deleteMessage': 'এই ফ্ল্যাটটি ডিলিট করতে চান?',
    'flat.flatName': 'ফ্ল্যাটের নাম',
    'flat.payDay': 'পেমেন্টের দিন',
    'flat.dayOfMonth': 'মাসের দিন',
    'flat.flatRentAmount': 'ফ্ল্যাট ভাড়ার পরিমাণ',
    'flat.paymentStyle': 'পেমেন্ট ধরন',
    'flat.afterMonth': 'পরের মাসে',
    'flat.runningMonth': 'চলতি মাসে',
    'flat.appliedBills': 'প্রযোজ্য বিল',
    'flat.gas': 'গ্যাস',
    'flat.water': 'পানি',
    'flat.electric': 'বিদ্যুৎ',
    'flat.serviceChargeOther': 'সার্ভিস চার্জ + অন্যান্য',
    'flat.negativeCharge': 'নেগেটিভ চার্জ',
    'flat.negativeChargeName': 'নেগেটিভ চার্জের নাম',
    'flat.addButton': 'ফ্ল্যাট যোগ করুন',
    'flat.updateButton': 'ফ্ল্যাট আপডেট করুন',
    'flat.optionalAmount': 'এখানে পরিমাণ লিখুন (ঐচ্ছিক)',

    'payment.modalNewTitle': 'পেমেন্ট নিন',
    'payment.modalEditTitle': 'পেমেন্ট সম্পাদনা',
    'payment.deleteTitle': 'পেমেন্ট ডিলিট',
    'payment.deleteMessage': 'এই পেমেন্টটি ডিলিট করতে চান?',
    'payment.renter': 'ভাড়াটিয়া',
    'payment.renterInfo': 'ভাড়াটিয়ার তথ্য',
    'payment.name': 'নাম',
    'payment.mobile': 'মোবাইল',
    'payment.email': 'ইমেইল',
'payment.photoId': 'এনআইডি/জন্ম নিবন্ধন নং',
    'payment.address': 'ঠিকানা',
    'payment.previousAddress': 'পূর্বের ঠিকানা',
    'payment.billingMonth': 'বিলিং মাস',
    'payment.paymentDate': 'পেমেন্ট তারিখ',
    'payment.paymentMethod': 'পেমেন্ট পদ্ধতি',
    'payment.remarks': 'মন্তব্য',
    'payment.remarksPlaceholder': 'মন্তব্য লিখুন (সর্বোচ্চ ১০০ অক্ষর)',
    'payment.amountDetails': 'টাকার বিবরণ',
    'payment.flatRent': 'ফ্ল্যাট ভাড়া',
    'payment.adjustFromAdvance': 'অ্যাডভান্স থেকে সমন্বয়',
    'payment.remainingAdvance': 'বাকি অ্যাডভান্স',
    'payment.addButton': 'পেমেন্ট যোগ করুন',
    'payment.updateButton': 'পেমেন্ট আপডেট করুন',
    'payment.successCreated': 'পেমেন্ট সফলভাবে তৈরি হয়েছে।',

    'expense.modalNewTitle': 'নতুন খরচ',
    'expense.modalEditTitle': 'খরচ সম্পাদনা',
    'expense.deleteTitle': 'খরচ ডিলিট',
    'expense.deleteMessage': 'এই খরচটি ডিলিট করতে চান?',
    'expense.expenseDate': 'খরচের তারিখ',
    'expense.expenseAmount': 'খরচের পরিমাণ',
    'expense.remarks': 'মন্তব্য',
    'expense.addButton': 'খরচ যোগ করুন',
    'expense.updateButton': 'খরচ আপডেট করুন',

    'user.employeeTab': 'সাবইউজার',
    'user.packageTab': 'প্যাকেজ',
    'user.assignPackageTab': 'প্যাকেজ অ্যাসাইন',
    'user.addEmployee': 'সাবইউজার যোগ করুন',
    'user.employeeImageUpdate': 'সাবইউজারের ছবি আপডেট',
    'user.uploadModalEditTitle': 'সাবইউজারের ছবি সম্পাদনা',
    'user.uploadModalCreateTitle': 'সাবইউজারের ছবি আপলোড',
    'user.uploadHint': 'ঐচ্ছিক: আপনি এই ধাপটি এড়িয়ে গিয়ে পরে আপলোড করতে পারেন।',
    'user.imageUpdatedSuccess': 'সাবইউজারের ছবি সফলভাবে আপডেট হয়েছে।',
    'user.modalNewTitle': 'নতুন সাবইউজার',
    'user.modalEditTitle': 'সাবইউজার সম্পাদনা',
    'user.deleteTitle': 'সাবইউজার ডিলিট',
    'user.deleteMessage': 'এই সাবইউজারকে ডিলিট করতে চান?',
    'user.name': 'নাম',
    'user.mobile': 'মোবাইল',
    'user.email': 'ইমেইল',
    'user.addButton': 'সাবইউজার যোগ করুন',
    'user.updateButton': 'সাবইউজার আপডেট করুন',
    'user.existingFile': 'আগের ফাইল',
    'user.noFileSelected': 'কোনো ফাইল নির্বাচিত হয়নি।',
    'user.saveImage': 'ছবি সংরক্ষণ করুন',
    'package.modalNewTitle': 'নতুন প্যাকেজ',
    'package.modalEditTitle': 'প্যাকেজ সম্পাদনা',
    'package.deleteTitle': 'প্যাকেজ ডিলিট',
    'package.deleteMessage': 'এই প্যাকেজটি ডিলিট করতে চান?',
    'package.name': 'প্যাকেজ নাম',
    'package.totalFlat': 'মোট ফ্ল্যাট',
    'package.totalRenter': 'মোট ভাড়াটিয়া',
    'package.maxActiveEmployee': 'সাবইউজার',
    'package.maxFileMemory': 'সর্বোচ্চ ফাইল মেমোরি (এমবি)',
    'package.priceMonthly': 'মাসিক মূল্য',
    'package.priceYearly': 'বার্ষিক মূল্য',
    'package.addButton': 'প্যাকেজ যোগ করুন',
    'package.updateButton': 'প্যাকেজ আপডেট করুন',
    'package.placeholder.name': 'প্যাকেজ নাম লিখুন',
    'package.table.name': 'প্যাকেজ',
    'package.table.flat': 'ফ্ল্যাট',
    'package.table.renter': 'ভাড়াটিয়া',
    'package.table.subuser': 'সাবইউজার',
    'package.table.monthly': 'মাসিক',
    'package.table.yearly': 'বার্ষিক',
    'assignPackage.modalNewTitle': 'নতুন প্যাকেজ অ্যাসাইন',
    'assignPackage.modalEditTitle': 'প্যাকেজ অ্যাসাইন সম্পাদনা',
    'assignPackage.deleteTitle': 'অ্যাসাইন করা প্যাকেজ ডিলিট',
    'assignPackage.deleteMessage': 'এই প্যাকেজ অ্যাসাইনমেন্টটি ডিলিট করতে চান?',
    'assignPackage.addButton': 'প্যাকেজ অ্যাসাইন করুন',
    'assignPackage.updateButton': 'অ্যাসাইন আপডেট করুন',
    'assignPackage.user': 'ব্যবহারকারী',
    'assignPackage.package': 'প্যাকেজ',
    'assignPackage.duration': 'মেয়াদ',
    'assignPackage.durationMonthly': 'মাসিক',
    'assignPackage.durationYearly': 'বার্ষিক',
    'assignPackage.durationCustom': 'কাস্টম',
    'assignPackage.durationQuantity': 'মেয়াদের সংখ্যা',
    'assignPackage.price': 'মূল্য',
    'assignPackage.expireDate': 'মেয়াদ শেষের তারিখ',
    'assignPackage.table.duration': 'মেয়াদ',
    'assignPackage.table.scale': 'স্কেল',
    'assignPackage.table.expireDate': 'মেয়াদ শেষ',

    'dashboard.loading': 'ড্যাশবোর্ড লোড হচ্ছে...',
    'dashboard.guideTitle': 'ড্যাশবোর্ড গাইড',
    'dashboard.guideMonthTitle': '১. ড্যাশবোর্ড মাস নির্বাচন',
    'dashboard.guideMonthIntro': 'মাস পরিবর্তন করলে এই তথ্যগুলো আপডেট হবে:',
    'dashboard.guideMonthItemCollection': 'কালেকশন (পেমেন্ট)',
    'dashboard.guideMonthItemExpense': 'খরচ',
    'dashboard.guideMonthItemNet': 'নেট কালেকশন',
    'dashboard.guideMonthItemPending': 'পেন্ডিং কালেকশন',
    'dashboard.guideMonthItemPendingList': 'পেন্ডিং কালেকশন তালিকা',
    'dashboard.guideSummaryTitle': '২. মাসিক সারসংক্ষেপ + শুধু ভাড়া',
    'dashboard.guideSummaryIntro': 'শুধু ভাড়া সুইচ চালু করলে ভাড়াভিত্তিক হিসাব দেখাবে।',
    'dashboard.guideSummaryItemOff': 'সুইচ বন্ধ: কালেকশনে ভাড়া ও সব বিল থাকবে, তারপর অ্যাডভান্স সমন্বয় বাদ যাবে।',
    'dashboard.guideSummaryItemOn': 'সুইচ চালু: শুধু ভাড়া দেখাবে, তারপর অ্যাডভান্স সমন্বয় বাদ যাবে।',
    'dashboard.guideSummaryItemExpense': 'খরচ: নির্বাচিত মাসের মোট খরচ।',
    'dashboard.guideSummaryItemNet': 'নেট কালেকশন: কালেকশন - খরচ।',
    'dashboard.guideSummaryItemPending': 'পেন্ডিং কালেকশন: দেখানো রেঞ্জের বকেয়া মোট টাকা।',
    'dashboard.guidePendingTitle': '৩. পেন্ডিং কালেকশন তালিকা',
    'dashboard.guidePendingIntro': 'এখানে ফ্ল্যাট, মাস ও টাকার তথ্য দেখাবে।',
    'dashboard.guidePendingItemFilter': 'বাড়ি, ফ্লোর, ফ্ল্যাট দিয়ে ফিল্টার করা যাবে।',
    'dashboard.guidePendingItemClick': 'যেকোনো সারিতে ক্লিক করলে বিস্তারিত খুলবে।',
    'dashboard.guidePendingItemAddPayment': 'ডিটেইলস মডাল থেকে পেমেন্ট যোগ করা যাবে।',
    'dashboard.guideYearlyTitle': '৪. বার্ষিক চার্ট (কালেকশন/খরচ)',
    'dashboard.guideYearlyIntro': 'বার্ষিক চার্টের আলাদা ফিল্টার আছে: বছর, ধরন, বাড়ি, ফ্ল্যাট।',
    'dashboard.guideYearlySummary': 'বারগুলো মাসভিত্তিক মোট দেখায়, আর উপরের মোটে সব মাসের যোগফল দেখায়।',
    'dashboard.guideYearlyItemOff': 'ধরন = কালেকশন + শুধু ভাড়া বন্ধ: পূর্ণ কালেকশন দেখাবে।',
    'dashboard.guideYearlyItemOn': 'ধরন = কালেকশন + শুধু ভাড়া চালু: শুধু ভাড়া দেখাবে, অ্যাডভান্স সমন্বয় বাদ যাবে। ফল ঋণাত্মক হলে ০ দেখাবে।',
    'dashboard.guideYearlyItemClick': 'যেকোনো বার-এ ক্লিক করলে ভাঙা হিসাব দেখা যাবে।',
    'dashboard.guideYearlyItemAdvance': 'শুধু ভাড়া মোডে Advance Adjusted (-) আলাদা দেখাবে।',
    'dashboard.guideSnapshotTitle': '৫. বর্তমান সক্রিয় অবস্থা',
    'dashboard.guideSnapshotIntro': 'এখানে বর্তমান সক্রিয় সংখ্যা দেখাবে:',
    'dashboard.monthlySummary': 'মাসিক সারসংক্ষেপ',
    'dashboard.collectionPayment': 'কালেকশন (পেমেন্ট)',
    'dashboard.transactions': 'টি লেনদেন',
    'dashboard.expenseCount': 'টি খরচ',
    'dashboard.netCollection': 'নেট কালেকশন',
    'dashboard.collectionMinusExpense': 'কালেকশন - খরচ',
    'dashboard.pendingCollection': 'পেন্ডিং কালেকশন',
    'dashboard.pendingAmountForDisplayedRange': 'দেখানো রেঞ্জের বকেয়া পরিমাণ',
    'dashboard.rentOnly': 'শুধু ভাড়া',
    'dashboard.yearly': 'বার্ষিক',
    'dashboard.type': 'ধরন',
    'dashboard.selectType': 'ধরন নির্বাচন করুন',
    'dashboard.report': 'রিপোর্ট',
    'dashboard.total': 'মোট',
    'dashboard.totalEntries': 'মোট এন্ট্রি',
    'dashboard.loadingYearly': 'বার্ষিক তথ্য লোড হচ্ছে...',
    'dashboard.loadingPendingList': 'পেন্ডিং তালিকা লোড হচ্ছে...',
    'dashboard.noPendingData': 'কোনো পেন্ডিং তথ্য পাওয়া যায়নি।',
    'dashboard.noRowsMatch': 'ফিল্টারের সাথে মিল পাওয়া যায়নি।',
    'dashboard.breakdownExpense': 'খরচের ভাঙা হিসাব',
    'dashboard.breakdownCollection': 'কালেকশনের ভাঙা হিসাব',
    'dashboard.breakdownTotal': 'মোট',
    'dashboard.metric.collection': 'কালেকশন',
    'dashboard.metric.expense': 'খরচ',
    'dashboard.legend.rent': 'ভাড়া',
    'dashboard.legend.gas': 'গ্যাস',
    'dashboard.legend.electric': 'বিদ্যুৎ',
    'dashboard.legend.water': 'পানি',
    'dashboard.legend.serviceOther': 'সার্ভিস + অন্যান্য',
    'dashboard.legend.negativeCharge': 'নেগেটিভ চার্জ (-)',
    'dashboard.legend.advanceAdjusted': 'অ্যাডভান্স সমন্বয় (-)',
    'dashboard.allHouses': 'সব বাড়ি',
    'dashboard.allFloors': 'সব ফ্লোর',
    'dashboard.allFlats': 'সব ফ্ল্যাট',
    'dashboard.selectFlatFirst': 'আগে ফ্ল্যাট নির্বাচন করুন।',
    'dashboard.noDataForFlat': 'এই ফ্ল্যাটের জন্য কোনো তথ্য পাওয়া যায়নি।',
    'dashboard.otherExpense': 'অন্যান্য খরচ',
    'dashboard.unknownMonth': 'অজানা',
    'dashboard.house': 'বাড়ি',
    'dashboard.flat': 'ফ্ল্যাট',
    'dashboard.month': 'মাস',
    'dashboard.amount': 'পরিমাণ',
    'dashboard.totalRenter': 'মোট ভাড়াটিয়া',
    'dashboard.availableRenter': 'খালি ভাড়াটিয়া',
    'dashboard.availableFlats': 'খালি ফ্ল্যাট',

    'report.yearlyTitle': 'বার্ষিক কালেকশন/খরচ রিপোর্ট',
    'report.pdf': 'পিডিএফ',
    'report.flatInformation': 'ফ্ল্যাটের তথ্য',
    'report.loading': 'রিপোর্ট লোড হচ্ছে...',
    'report.noDataForFlat': 'এই ফ্ল্যাটের জন্য কোনো তথ্য পাওয়া যায়নি।',
    'report.collectionDetails': 'কালেকশনের বিস্তারিত',
    'report.expenseDetails': 'খরচের বিস্তারিত',
    'report.monthName': 'মাসের নাম',
    'report.renter': 'ভাড়াটিয়া',
    'report.paymentDate': 'পেমেন্ট তারিখ',
    'report.flatRent': 'ফ্ল্যাট ভাড়া',
    'report.gasBill': 'গ্যাস বিল',
    'report.electricBill': 'বিদ্যুৎ বিল',
    'report.waterBill': 'পানির বিল',
    'report.serviceChargeOther': 'সার্ভিস চার্জ + অন্যান্য',
    'report.adjustFromAdvance': 'অ্যাডভান্স থেকে সমন্বয়',
    'report.totalAmount': 'মোট পরিমাণ',
    'report.finalTotal': 'সর্বমোট',
    'report.noCollectionData': 'কোনো কালেকশন তথ্য পাওয়া যায়নি।',
    'report.expenseDate': 'খরচের তারিখ',
    'report.expenseHead': 'খরচের খাত',
    'report.amount': 'পরিমাণ',
    'report.noExpenseData': 'কোনো খরচের তথ্য পাওয়া যায়নি।',
    'report.overallTotals': 'সামগ্রিক মোট',
    'report.collection': 'কালেকশন',
    'report.expense': 'খরচ',
    'report.netCollectionMinusExpense': 'নেট (কালেকশন - খরচ)',
    'report.rentOnlyTotals': 'শুধু ভাড়ার মোট',
    'report.totalFlatRent': 'মোট ফ্ল্যাট ভাড়া',
    'report.totalFlatRentInfo': 'মোট ফ্ল্যাট ভাড়ার হিসাব দেখুন',
    'report.netRentMinusExpense': 'নেট (ভাড়া - খরচ)',
    'report.generatedOn': 'তৈরির সময়',
    'report.generatedBy': 'তৈরি করেছেন',
    'report.totalFlatRentCalculation': 'মোট ফ্ল্যাট ভাড়ার হিসাব',
    'report.totalFlatRentFormula': 'মোট ফ্ল্যাট ভাড়া = ফ্ল্যাট ভাড়া -',
    'report.houseNo': 'বাড়ি নম্বর',
    'report.address': 'ঠিকানা',
    'report.flat': 'ফ্ল্যাট',
    'report.floor': 'ফ্লোর',
    'report.house': 'বাড়ি',
    'report.month': 'মাস',
    'report.payDate': 'পে. তারিখ',
    'report.rent': 'ভাড়া',
    'report.gas': 'গ্যাস',
    'report.elec': 'বিদ্যুৎ',
    'report.water': 'পানি',
    'report.service': 'সার্ভিস',
    'report.total': 'মোট',
    'report.collectionDetailsCont': 'কালেকশনের বিস্তারিত (চলমান)',
    'report.expenseDetailsCont': 'খরচের বিস্তারিত (চলমান)',
    'report.developedBy': 'ডেভেলপ করেছে',

    'signIn.title': 'লগইন',
    'signIn.emailPlaceholder': 'ইমেইল লিখুন',
    'signIn.passwordPlaceholder': 'পাসওয়ার্ড লিখুন',
    'signIn.rememberMe': 'আমাকে মনে রাখুন',
    'signIn.forgotPassword': 'পাসওয়ার্ড ভুলে গেছেন?',
    'signIn.error.invalidCredentials': 'ইউজারনেম বা পাসওয়ার্ড সঠিক নয়।',
    'signIn.submit': 'লগইন করুন',
    'signIn.processing': 'প্রসেস হচ্ছে...',
    'signIn.newTo': 'HTally-তে নতুন?',
    'signIn.signUp': 'সাইন আপ',
    'signIn.illustrationAlt': 'লগইন ইলাস্ট্রেশন',
    'signIn.forgot.title': 'পাসওয়ার্ড রিসেট',
    'signIn.forgot.copy': 'ইমেইলে ওটিপি নিন, যাচাই করুন, তারপর নতুন পাসওয়ার্ড সেট করুন।',
    'signIn.forgot.email': 'ইমেইল',
    'signIn.forgot.emailPlaceholder': 'ইমেইল লিখুন',
    'signIn.forgot.sendOtp': 'ওটিপি পাঠান',
    'signIn.forgot.resendOtp': 'ওটিপি আবার পাঠান',
    'signIn.forgot.sending': 'পাঠানো হচ্ছে...',
    'signIn.forgot.otp': 'ওটিপি',
    'signIn.forgot.otpPlaceholder': 'ওটিপি লিখুন',
    'signIn.forgot.otpExpiresIn': 'ওটিপির সময় বাকি',
    'signIn.forgot.otpExpired': 'ওটিপির সময় শেষ। আবার পাঠান।',
    'signIn.forgot.newPassword': 'নতুন পাসওয়ার্ড',
    'signIn.forgot.newPasswordPlaceholder': 'নতুন পাসওয়ার্ড লিখুন',
    'signIn.forgot.confirmPassword': 'পাসওয়ার্ড আবার লিখুন',
    'signIn.forgot.confirmPasswordPlaceholder': 'পাসওয়ার্ড আবার লিখুন',
    'signIn.forgot.submit': 'সাবমিট ও পাসওয়ার্ড আপডেট',
    'signIn.forgot.updating': 'আপডেট হচ্ছে...',

    'signUp.title': 'সাইন আপ',
    'signUp.stepProfile': '১. প্রোফাইল',
    'signUp.stepCredentials': '২. লগইন তথ্য',
    'signUp.stepOtp': '৩. ওটিপি',
    'signUp.next': 'পরের ধাপ',
    'signUp.passwordHint': 'কমপক্ষে ৬ অক্ষর ব্যবহার করুন।',
    'signUp.sendOtp': 'ওটিপি পাঠান',
    'signUp.sendingOtp': 'ওটিপি পাঠানো হচ্ছে...',
    'signUp.otpExpiresIn': 'ওটিপির সময় বাকি',
    'signUp.otpExpired': 'ওটিপির সময় শেষ। দয়া করে আগের ধাপে গিয়ে আবার ওটিপি পাঠান।',
    'signUp.complete': 'সাইন আপ সম্পন্ন করুন',
    'signUp.creatingAccount': 'অ্যাকাউন্ট তৈরি হচ্ছে...',
    'signUp.alreadyOnHtally': 'আগেই HTally-তে আছেন?',
    'signUp.signIn': 'সাইন ইন',
    'signUp.imageModalTitle': 'প্রতিষ্ঠানের লোগো যোগ করুন',
    'signUp.imageModalHint': 'ঐচ্ছিক: চাইলে এখন এড়িয়ে গিয়ে পরে আপলোড করতে পারবেন।',
    'signUp.imageRules': 'অনুমোদিত: .jpg, .jpeg, .png | সর্বোচ্চ: ১টি ফাইল | সর্বোচ্চ সাইজ: ৫MB',
    'signUp.logoPreviewAlt': 'প্রতিষ্ঠানের লোগো প্রিভিউ',
    'signUp.noFileSelected': 'কোনো ফাইল নির্বাচন করা হয়নি।',
    'signUp.oneFileSelected': '১টি ফাইল নির্বাচন করা হয়েছে',
    'signUp.signupCompleted': 'সাইন আপ সম্পন্ন হয়েছে।'
    ,'entityList.empty': 'কোনো তথ্য পাওয়া যায়নি।',
    'entityList.moreOptions': 'আরও অপশন',

    'action.edit': 'সম্পাদনা',
    'action.delete': 'ডিলিট',
    'action.history': 'ইতিহাস',
    'action.receiptDownload': 'রসিদ ডাউনলোড',
    'action.receiptPrint': 'রসিদ প্রিন্ট',
    'action.sendReceipt': 'রসিদ পাঠান',

    'table.transactionNo': 'ট্রানজেকশন নং',
    'table.name': 'নাম',
    'table.mobile': 'মোবাইল',
    'table.email': 'ইমেইল',
'table.photoId': 'এনআইডি/জন্ম নিবন্ধন নং',
    'table.renter': 'ভাড়াটিয়া',
    'table.flat': 'ফ্ল্যাট',
    'table.house': 'বাড়ি',
    'table.paymentMonth': 'পেমেন্ট মাস',
    'table.paymentDate': 'পেমেন্ট তারিখ',
    'table.amount': 'পরিমাণ',
    'table.expenseHead': 'খরচের খাত',
    'table.expenseMonth': 'খরচের মাস',
    'table.expenseDate': 'খরচের তারিখ',
    'table.startDate': 'শুরুর তারিখ',
    'table.totalIncome': 'মোট আয়',
    'table.paymentStatus': 'পেমেন্ট অবস্থা',
    'menu.SUBSCRIPTION_MENU': 'সাবস্ক্রিপশন',
    'subscription.eyebrow': 'ফ্ল্যাট ভিত্তিক প্ল্যান',
    'subscription.title': 'সাবস্ক্রিপশন প্ল্যান বেছে নিন',
    'subscription.subtitle': '৫ টি ফ্ল্যাট দিয়ে ফ্রি শুরু করুন। পরে প্রয়োজন হলে ফ্ল্যাট লিমিট ভিত্তিক আপগ্রেড করুন।',
    'subscription.loading': 'সাবস্ক্রিপশন তথ্য লোড হচ্ছে...',
    'subscription.recommended': 'প্রস্তাবিত',
    'subscription.freePlan': 'ফ্রি চিরদিন',
    'subscription.currentPackage': 'বর্তমান প্যাকেজ',
    'subscription.yearlySave': '২ মাসের বিল সাশ্রয়',
    'subscription.flats': 'এক্টিভ ফ্ল্যাট',
    'subscription.renters': 'এক্টিভ ভাড়াটিয়া',
    'subscription.subusers': 'সাবইউজার',
    'subscription.storage': 'ফাইল স্টোরেজ',
    'subscription.packageExpireDate': 'প্যাকেজের মেয়াদ শেষের তারিখ',
    'subscription.policyTitle': 'পলিসি সারাংশ',
    'subscription.policyFlat': 'প্রধান প্যাকেজ লিমিট হবে এক্টিভ ফ্ল্যাট সংখ্যা।',
    'subscription.policyStorage': 'অ্যাটাচমেন্ট ও ফাইল আপলোড প্যাকেজ স্টোরেজ লিমিটের মধ্যে থাকবে।',
    'subscription.policyUpgrade': '৫ টি ফ্ল্যাট ফ্রি। ৬ষ্ঠ ফ্ল্যাট থেকে মাসিক অথবা বার্ষিক সাবস্ক্রিপশন লাগবে।',
    'subscription.contactTitle': 'সাবস্ক্রিপশনের জন্য যোগাযোগ',
    'subscription.contactSubtitle': 'সাবস্ক্রিপশন অ্যাক্টিভেশন বা আপগ্রেড সহায়তার জন্য হোয়াটসঅ্যাপ, মোবাইল অথবা ইমেইল ব্যবহার করুন। ভবিষ্যতে পেমেন্ট মেথড যুক্ত করা হবে।',
    'subscription.whatsapp': 'হোয়াটসঅ্যাপ / মোবাইল',
    'subscription.email': 'ইমেইল'
  },
  en: {
    'language.bn': 'Bangla',
    'language.en': 'English',
    'language.bnShort': 'BN',
    'language.enShort': 'EN',

    'menu.DASHBOARD': 'Dashboard',
    'menu.PAYMENT_LIST': 'Transaction',
    'menu.RENTER_LIST': 'Renter',
    'menu.HOUSE_LIST': 'House',
    'menu.USER_LIST': 'Other',
    'menu.HELP_USER_MANUAL': 'Help',

    'nav.signUp': 'Sign Up',
    'nav.signIn': 'Sign In',
    'nav.openMenu': 'Open menu',
    'nav.expandSidebar': 'Expand sidebar',
    'nav.collapseSidebar': 'Collapse sidebar',

    'common.filter': 'Filter',
    'common.apply': 'Apply',
    'common.reset': 'Reset',
    'common.data': 'Data',
    'common.showDeletedData': 'Show deleted data',
    'common.startDate': 'Start date',
    'common.endDate': 'End date',
    'common.option': 'Option',
    'common.clearSelection': 'Clear selection',
    'common.noOptionFound': 'No option found',
    'common.loading': 'Loading...',
    'common.dropdownConfigRequired': 'Dropdown config requires setup.',
    'common.invalidDropdownApiInfo': 'Invalid dropdown api info.',
    'common.unableToLoadDropdownOptions': 'Unable to load dropdown options.',
    'common.user': 'User',
    'common.na': 'N/A',
    'common.close': 'Close',
    'common.search': 'Search',
    'common.download': 'Download',
    'common.show': 'Show',
    'common.hide': 'Hide',
    'common.limit': 'Limit',
    'common.storage': 'File Storage',
    'common.used': 'used',
    'common.copy': 'Copy',
    'common.copied': 'Copied',
    'common.active': 'Active',
    'common.inactive': 'Inactive',
    'common.saving': 'Saving...',
    'common.updating': 'Updating...',
    'common.uploading': 'Uploading...',
    'common.uploadingAction': 'Upload',
    'common.selectFile': 'Select File',
    'common.remove': 'Remove',
    'common.preview': 'Preview',
    'common.changeLogo': 'Change Logo',
    'common.done': 'Done',
    'common.skip': 'Skip',
    'common.skipForNow': 'Skip for now',
    'common.next': 'Next',

    'page.dashboard': 'Dashboard',
    'page.transaction': 'Transaction',
    'page.expense': 'Expense',
    'page.renter': 'Renter',
    'page.house': 'House',
    'page.deleted': 'Deleted',
    'page.user': 'User',
    'page.activity': 'Activity',
    'page.other': 'Other',
    'page.subscription': 'Subscription',
    'page.helpUserManual': 'Help',

    'help.userManualTab': 'User Manual',
    'help.videoTutorialsTab': 'Video tutorials',
    'help.faqTab': 'FAQ',
    'help.comingSoon': 'Comming soon',

    'month.january': 'January',
    'month.february': 'February',
    'month.march': 'March',
    'month.april': 'April',
    'month.may': 'May',
    'month.june': 'June',
    'month.july': 'July',
    'month.august': 'August',
    'month.september': 'September',
    'month.october': 'October',
    'month.november': 'November',
    'month.december': 'December',
    'monthShort.january': 'Jan',
    'monthShort.february': 'Feb',
    'monthShort.march': 'Mar',
    'monthShort.april': 'Apr',
    'monthShort.may': 'May',
    'monthShort.june': 'Jun',
    'monthShort.july': 'Jul',
    'monthShort.august': 'Aug',
    'monthShort.september': 'Sep',
    'monthShort.october': 'Oct',
    'monthShort.november': 'Nov',
    'monthShort.december': 'Dec',

    'paymentMethod.cash': 'Cash',
    'paymentMethod.bank': 'Bank',
    'paymentMethod.cheque': 'Cheque',
    'paymentMethod.mobileBanking': 'Mobile Banking',
    'paymentMethod.adjustFromAdvance': 'Adjust From Advance',
    'paymentMethod.other': 'Other',

    'filter.house': 'House',
    'filter.flat': 'Flat',
    'filter.renter': 'Renter',
    'filter.transactionNo': 'Transaction No',
    'filter.paymentYear': 'Payment Year',
    'filter.paymentMonth': 'Payment Month',
    'filter.paymentMethod': 'Payment Method',
    'filter.paymentDateRange': 'Payment Date Range',
    'filter.createdOnRange': 'Created On Range',
    'filter.expenseHead': 'Expense Head',
    'filter.expenseYear': 'Expense Year',
    'filter.expenseMonth': 'Expense Month',
    'filter.expenseDateRange': 'Expense Date Range',
    'filter.renterName': 'Renter Name',
    'filter.mobile': 'Mobile',
    'filter.email': 'Email',
'filter.photoId': 'NID/Birth Reg No',
    'filter.renterMobile': 'Renter Mobile',
    'filter.flatName': 'Flat Name',
    'filter.houseName': 'House Name',
    'filter.address': 'Address',
    'filter.floor': 'Floor',
    'filter.employeeName': 'Subuser Name',

    'placeholder.selectHouse': 'Select house',
    'placeholder.selectFlat': 'Select flat',
    'placeholder.selectRenter': 'Select renter',
    'placeholder.selectUser': 'Select user',
    'placeholder.selectPackage': 'Select package',
    'placeholder.selectDuration': 'Select duration',
    'placeholder.selectYear': 'Select year',
    'placeholder.selectMonth': 'Select month',
    'placeholder.selectExpenseHead': 'Select expense head',
    'placeholder.selectFloor': 'Select floor',
    'placeholder.selectDate': 'Select date',
    'placeholder.selectEndDateOptional': 'Select end date (optional)',
    'placeholder.typeTransactionNo': 'Type transaction no',
    'placeholder.typeRenterName': 'Type renter name',
    'placeholder.typeMobileNumber': 'Type mobile number',
    'placeholder.typeRenterMobile': 'Type renter mobile',
    'placeholder.typeEmail': 'Type email',
'placeholder.typePhotoId': 'Type NID/Birth Reg no',
    'placeholder.typeFlatName': 'Type flat name',
    'placeholder.typeHouseName': 'Type house name',
    'placeholder.typeAddress': 'Type address',
    'placeholder.typeEmployeeName': 'Type subuser name',
    'placeholder.typeEmployeeEmail': 'Type subuser email',
    'placeholder.typeRenterEmail': 'Type renter email',
'placeholder.typePhotoIdNumber': 'Type NID/Birth Reg no',
    'placeholder.typePermanentAddress': 'Type permanent address',
    'placeholder.typePreviousAddress': 'Type previous address',
    'placeholder.typeAdvanceAmount': 'Type advance amount',
    'placeholder.typeAmount': 'Type amount',
    'placeholder.typeRemarksOptional': 'Type remarks (optional)',
    'placeholder.typeFullName': 'Type full name',
    'placeholder.typeOrganizationName': 'Type organization/housing name',
    'placeholder.typeCurrentPassword': 'Type current password',
    'placeholder.typeNewPassword': 'Type new password',
    'placeholder.retypeNewPassword': 'Retype password',
    'placeholder.typeNewEmail': 'Type new email',
    'placeholder.typeOtp': 'Type OTP',
    'placeholder.typeOtpFromNewEmail': 'Type OTP from new email',
    'placeholder.autoFromSelectedFlat': 'Auto from selected flat',
    'placeholder.typeFlatRentAmount': 'Type flat rent amount',
    'placeholder.typeNegativeChargeName': 'Negative charge name',
    'placeholder.typeFullAddress': 'Type full address',
    'placeholder.typeFloorName': 'Type floor name',

    'topHeader.pageInfo': 'Page info',
    'topHeader.month': 'Month',
    'topHeader.year': 'Year',
    'topHeader.apply': 'Apply',
    'topHeader.editImage': 'Edit image',
    'topHeader.editProfile': 'Edit Profile',
    'topHeader.updatePassword': 'Update Password',
    'topHeader.logout': 'Logout',
    'topHeader.updateOrganizationLogo': 'Update Organization Logo',
    'topHeader.chooseImage': 'Choose Image',
    'topHeader.allowed': 'Allowed',
    'topHeader.maxSize': 'Max size',
    'topHeader.updateProfile': 'Update Profile',
    'topHeader.basic': 'Basic',
    'topHeader.fullName': 'Full Name',
    'topHeader.organizationName': 'Organization/Housing Name',
    'topHeader.mobileNumber': 'Mobile Number',
    'topHeader.saveBasicInfo': 'Save Basic Info',
    'topHeader.password': 'Password',
    'topHeader.currentPassword': 'Current Password',
    'topHeader.newPassword': 'New Password',
    'topHeader.retypeNewPassword': 'Retype New Password',
    'topHeader.updatePasswordButton': 'Update Password',
    'topHeader.email': 'Email',
    'topHeader.newEmail': 'New Email',
    'topHeader.sendOtp': 'Send OTP',
    'topHeader.resendOtp': 'Resend OTP',
    'topHeader.otp': 'OTP',
    'topHeader.otpExpiresIn': 'OTP expires in',
    'topHeader.otpExpired': 'OTP expired. Resend OTP.',
    'topHeader.updateEmail': 'Update Email',

    'transaction.paymentTab': 'Payment',
    'transaction.expenseTab': 'Expense',
    'transaction.addPayment': 'Add Payment',
    'transaction.addExpense': 'Add Expense',
    'transaction.paymentCreateBlockedExpired': 'Please renew your package to create payment.',
    'transaction.expenseCreateBlockedExpired': 'Please renew your package to create expense.',

    'renter.renterTab': 'Renter',
    'renter.assignFlatTab': 'Flat Assignment',
    'renter.addRenter': 'Add Renter',
    'renter.assignFlat': 'Assign Flat',
    'renter.postCreatePromptTitle': 'Assign flat for renter',
    'renter.postCreatePromptMessage': 'You can assign a flat now or skip this step for later.',
    'renter.imageUpdate': 'Renter Image Update',
    'renter.uploadModalEditTitle': 'Edit Renter Image',
    'renter.uploadModalCreateTitle': 'Upload Renter Image',
    'renter.uploadHint': 'Optional: You can skip this step and upload later.',
    'renter.modalNewTitle': 'New Renter',
    'renter.modalEditTitle': 'Edit Renter',
    'renter.deleteTitle': 'Delete Renter',
    'renter.deleteMessage': 'Delete this renter?',
    'renter.name': 'Name',
    'renter.mobile': 'Mobile',
    'renter.email': 'Email',
'renter.photoIdNo': 'NID/Birth Reg No',
    'renter.permanentAddress': 'Permanent Address',
    'renter.previousAddress': 'Previous Address',
    'renter.addButton': 'Add Renter',
    'renter.updateButton': 'Update Renter',
    'renter.detailsTitle': 'Renter Details',
    'renter.renterInformation': 'Renter Information',
    'renter.homeInformation': 'Home Information',
    'renter.agreementDocuments': 'Additional Documents',
    'renter.noAgreementDocument': 'No additional document uploaded.',
    'renter.detailsFullTitle': 'Renter Full Information',
    'renter.username': 'Username',
    'renter.startDate': 'Start Date',
    'renter.endDate': 'End Date',
    'renter.status': 'Status',
    'renter.advance': 'Advance',
    'renter.used': 'Used',
    'renter.remain': 'Remain',
    'renter.loadingPaymentList': 'Loading payment list...',
    'renter.noPaymentData': 'No payment data found.',
    'renter.invalidYear': 'Please provide a valid year (YYYY).',
    'renter.failedToLoadDetails': 'Failed to load renter details.',
    'renter.failedToLoadPaymentList': 'Failed to load renter payment list.',
    'renter.existingFile': 'Existing file',
    'renter.selectFile': 'Select File',
    'renter.fileSelectedSingular': 'file selected',
    'renter.fileSelectedPlural': 'files selected',
    'renter.noFileSelected': 'No file selected.',
    'renter.saveImage': 'Save Image',
    'renter.imageUpdatedSuccess': 'Renter image updated successfully.',

    'assign.modalNewTitle': 'Assign Flat',
    'assign.modalEditTitle': 'Edit Assign Flat',
    'assign.uploadModalEditTitle': 'Edit Additional Documents',
    'assign.uploadModalCreateTitle': 'Upload Additional Documents',
    'assign.uploadHint': 'Optional: You can skip this step and upload later.',
    'assign.uploadDocumentInfo': 'Upload agreement, NID, or any other relevant document for this flat assignment.',
    'assign.maxFiles': 'Max',
    'assign.files': 'files',
    'assign.existingFiles': 'Existing file(s)',
    'assign.selectFiles': 'Select File(s)',
    'assign.filesSelected': 'file(s) selected',
    'assign.noFilesSelected': 'No files selected.',
    'assign.saveDocuments': 'Save Documents',
    'assign.documentsUpdatedSuccess': 'Additional documents updated successfully.',
    'assign.detailsTitle': 'Assign Flat Details',
    'assign.processPayment': 'Process Payment',
    'assign.houseOptional': 'House (Optional)',
    'assign.floorOptional': 'Floor (Optional)',
    'assign.flat': 'Flat',
    'assign.renter': 'Renter',
    'assign.renterMobile': 'Renter Mobile',
    'assign.renterStartDate': 'Renter Start Date',
    'assign.renterEndDate': 'Renter End Date',
    'assign.advanceAmount': 'Advance Amount',
    'assign.usedAdvance': 'Used Advance',
    'assign.remainingAdvance': 'Remaining Advance',
    'assign.createdOn': 'Created On',
    'assign.endDateOptional': 'End Date (Optional)',
    'assign.endDateHint': 'For unassign, provide End Date. In edit, this field is optional.',
    'assign.agreementDocumentUpdate': 'Update Additional Documents',
    'assign.noDocumentUploaded': 'No document uploaded.',
    'assign.deleteTitle': 'Delete Assigned Flat',
    'assign.deleteMessage': 'Delete this assigned flat mapping?',
    'assign.addButton': 'Assign Flat',
    'assign.updateButton': 'Update Assign',

    'house.houseTab': 'House',
    'house.flatTab': 'Flat',
    'house.addHouse': 'Add House',
    'house.addFlat': 'Add Flat',
    'house.postCreatePromptTitle': 'Assign flat for the house',
    'house.postCreatePromptMessage': 'You can add a flat now or skip this step for later.',
    'house.modalNewTitle': 'New House',
    'house.modalEditTitle': 'Edit House',
    'house.deleteTitle': 'Delete House',
    'house.deleteMessage': 'Delete this house?',
    'house.houseNameOrNumber': 'House Name / Number',
    'house.address': 'Address',
    'house.totalFloor': 'Total Floor',
    'house.floor': 'Floor',
    'house.floorName': 'Floor Name',
    'house.addButton': 'Add House',
    'house.updateButton': 'Update House',
    'house.floorUnit': 'floor',

    'flat.modalNewTitle': 'New Flat',
    'flat.modalEditTitle': 'Edit Flat',
    'flat.deleteTitle': 'Delete Flat',
    'flat.deleteMessage': 'Delete this flat?',
    'flat.flatName': 'Flat Name',
    'flat.payDay': 'Pay Day',
    'flat.dayOfMonth': 'day of month',
    'flat.flatRentAmount': 'Flat Rent Amount',
    'flat.paymentStyle': 'Payment Style',
    'flat.afterMonth': 'After Month',
    'flat.runningMonth': 'Running Month',
    'flat.appliedBills': 'Applied Bills',
    'flat.gas': 'Gas',
    'flat.water': 'Water',
    'flat.electric': 'Electric',
    'flat.serviceChargeOther': 'Service Charge + Other',
    'flat.negativeCharge': 'Negative Charge',
    'flat.negativeChargeName': 'Negative Charge Name',
    'flat.addButton': 'Add Flat',
    'flat.updateButton': 'Update Flat',
    'flat.optionalAmount': 'Type amount here (optional)',

    'payment.modalNewTitle': 'Make Payment',
    'payment.modalEditTitle': 'Edit Payment',
    'payment.deleteTitle': 'Delete Payment',
    'payment.deleteMessage': 'Delete this payment?',
    'payment.renter': 'Renter',
    'payment.renterInfo': 'Renter Info',
    'payment.name': 'Name',
    'payment.mobile': 'Mobile',
    'payment.email': 'Email',
'payment.photoId': 'NID/Birth Reg No',
    'payment.address': 'Address',
    'payment.previousAddress': 'Previous',
    'payment.billingMonth': 'Billing Month',
    'payment.paymentDate': 'Payment Date',
    'payment.paymentMethod': 'Payment Method',
    'payment.remarks': 'Remarks',
    'payment.remarksPlaceholder': 'Type remarks (optional, max 100 characters)',
    'payment.amountDetails': 'Amount Details',
    'payment.flatRent': 'Flat Rent',
    'payment.adjustFromAdvance': 'Adjust From Advance',
    'payment.remainingAdvance': 'Remaining advance',
    'payment.addButton': 'Add Payment',
    'payment.updateButton': 'Update Payment',
    'payment.successCreated': 'Payment created successfully.',

    'expense.modalNewTitle': 'New Expense',
    'expense.modalEditTitle': 'Edit Expense',
    'expense.deleteTitle': 'Delete Expense',
    'expense.deleteMessage': 'Delete this expense?',
    'expense.expenseDate': 'Expense Date',
    'expense.expenseAmount': 'Expense Amount',
    'expense.remarks': 'Remarks',
    'expense.addButton': 'Add Expense',
    'expense.updateButton': 'Update Expense',

    'user.employeeTab': 'Subuser',
    'user.packageTab': 'Package',
    'user.assignPackageTab': 'Assign Package',
    'user.addEmployee': 'Add Subuser',
    'user.employeeImageUpdate': 'Subuser Image Update',
    'user.uploadModalEditTitle': 'Edit Subuser Image',
    'user.uploadModalCreateTitle': 'Upload Subuser Image',
    'user.uploadHint': 'Optional: You can skip this step and upload later.',
    'user.imageUpdatedSuccess': 'Subuser image updated successfully.',
    'user.modalNewTitle': 'New Subuser',
    'user.modalEditTitle': 'Edit Subuser',
    'user.deleteTitle': 'Delete Subuser',
    'user.deleteMessage': 'Delete this subuser?',
    'user.name': 'Name',
    'user.mobile': 'Mobile',
    'user.email': 'Email',
    'user.addButton': 'Add Subuser',
    'user.updateButton': 'Update Subuser',
    'user.existingFile': 'Existing file',
    'user.noFileSelected': 'No file selected.',
    'user.saveImage': 'Save Image',
    'package.modalNewTitle': 'New Package',
    'package.modalEditTitle': 'Edit Package',
    'package.deleteTitle': 'Delete Package',
    'package.deleteMessage': 'Delete this package?',
    'package.name': 'Package Name',
    'package.totalFlat': 'Total Flat',
    'package.totalRenter': 'Total Renter',
    'package.maxActiveEmployee': 'Subuser',
    'package.maxFileMemory': 'Max File Memory (MB)',
    'package.priceMonthly': 'Monthly Price',
    'package.priceYearly': 'Yearly Price',
    'package.addButton': 'Add Package',
    'package.updateButton': 'Update Package',
    'package.placeholder.name': 'Type package name',
    'package.table.name': 'Package',
    'package.table.flat': 'Flat',
    'package.table.renter': 'Renter',
    'package.table.subuser': 'Subuser',
    'package.table.monthly': 'Monthly',
    'package.table.yearly': 'Yearly',
    'assignPackage.modalNewTitle': 'New Assign Package',
    'assignPackage.modalEditTitle': 'Edit Assign Package',
    'assignPackage.deleteTitle': 'Delete Assigned Package',
    'assignPackage.deleteMessage': 'Delete this package assignment?',
    'assignPackage.addButton': 'Add Assign Package',
    'assignPackage.updateButton': 'Update Assign Package',
    'assignPackage.user': 'User',
    'assignPackage.package': 'Package',
    'assignPackage.duration': 'Duration',
    'assignPackage.durationMonthly': 'Monthly',
    'assignPackage.durationYearly': 'Yearly',
    'assignPackage.durationCustom': 'Custom',
    'assignPackage.durationQuantity': 'Duration Quantity',
    'assignPackage.price': 'Price',
    'assignPackage.expireDate': 'Expire Date',
    'assignPackage.table.duration': 'Duration',
    'assignPackage.table.scale': 'Scale',
    'assignPackage.table.expireDate': 'Expire Date',

    'dashboard.loading': 'Loading dashboard...',
    'dashboard.guideTitle': 'Dashboard Guide',
    'dashboard.guideMonthTitle': '1. Pick Dashboard Month',
    'dashboard.guideMonthIntro': 'When you change the month, these sections update:',
    'dashboard.guideMonthItemCollection': 'Collection (Payment)',
    'dashboard.guideMonthItemExpense': 'Expense',
    'dashboard.guideMonthItemNet': 'Net Collection',
    'dashboard.guideMonthItemPending': 'Pending Collection',
    'dashboard.guideMonthItemPendingList': 'Pending Collection list',
    'dashboard.guideSummaryTitle': '2. Monthly Summary + Rent Only',
    'dashboard.guideSummaryIntro': 'Use the Rent Only switch to show rent-focused values.',
    'dashboard.guideSummaryItemOff': 'Switch OFF: Collection includes rent and all bill items, then subtracts advance adjustment.',
    'dashboard.guideSummaryItemOn': 'Switch ON: Collection uses only rent, then subtracts advance adjustment.',
    'dashboard.guideSummaryItemExpense': 'Expense: Total amount spent in the selected month.',
    'dashboard.guideSummaryItemNet': 'Net Collection: Collection - Expense.',
    'dashboard.guideSummaryItemPending': 'Pending Collection: Total pending amount for the displayed range.',
    'dashboard.guidePendingTitle': '3. Pending Collection List',
    'dashboard.guidePendingIntro': 'Shows pending items with flat, month, and amount.',
    'dashboard.guidePendingItemFilter': 'Filter by House, Floor, and Flat.',
    'dashboard.guidePendingItemClick': 'Click any row to open details.',
    'dashboard.guidePendingItemAddPayment': 'Use Add Payment from the details modal.',
    'dashboard.guideYearlyTitle': '4. Yearly Chart (Collection/Expense)',
    'dashboard.guideYearlyIntro': 'The yearly chart has its own filters: Year, Type, House, Flat.',
    'dashboard.guideYearlySummary': 'Bars show month-wise totals, and the header total is the sum of all months.',
    'dashboard.guideYearlyItemOff': 'Type = Collection + Rent Only OFF: shows full collection.',
    'dashboard.guideYearlyItemOn': 'Type = Collection + Rent Only ON: shows rent only and subtracts advance adjustment. Negative results show as 0.',
    'dashboard.guideYearlyItemClick': 'Click any bar to open the breakdown.',
    'dashboard.guideYearlyItemAdvance': 'In rent-only mode, Advance Adjusted (-) is shown separately.',
    'dashboard.guideSnapshotTitle': '5. Active Snapshot',
    'dashboard.guideSnapshotIntro': 'Shows current active counts:',
    'dashboard.monthlySummary': 'Monthly Summary',
    'dashboard.collectionPayment': 'Collection (Payment)',
    'dashboard.transactions': 'transactions',
    'dashboard.expenseCount': 'expenses',
    'dashboard.netCollection': 'Net Collection',
    'dashboard.collectionMinusExpense': 'Collection - Expense',
    'dashboard.pendingCollection': 'Pending Collection',
    'dashboard.pendingAmountForDisplayedRange': 'Pending amount for displayed range',
    'dashboard.rentOnly': 'Rent Only',
    'dashboard.yearly': 'Yearly',
    'dashboard.type': 'Type',
    'dashboard.selectType': 'Select type',
    'dashboard.report': 'Report',
    'dashboard.total': 'Total',
    'dashboard.totalEntries': 'Total entries',
    'dashboard.loadingYearly': 'Loading yearly data...',
    'dashboard.loadingPendingList': 'Loading pending list...',
    'dashboard.noPendingData': 'No pending data found.',
    'dashboard.noRowsMatch': 'No rows match your filters.',
    'dashboard.breakdownExpense': 'Expense breakdown',
    'dashboard.breakdownCollection': 'Collection breakdown',
    'dashboard.breakdownTotal': 'Total',
    'dashboard.metric.collection': 'Collection',
    'dashboard.metric.expense': 'Expense',
    'dashboard.legend.rent': 'Rent',
    'dashboard.legend.gas': 'Gas',
    'dashboard.legend.electric': 'Electric',
    'dashboard.legend.water': 'Water',
    'dashboard.legend.serviceOther': 'Service + Other',
    'dashboard.legend.negativeCharge': 'Negative Charge (-)',
    'dashboard.legend.advanceAdjusted': 'Advance Adjusted (-)',
    'dashboard.allHouses': 'All houses',
    'dashboard.allFloors': 'All floors',
    'dashboard.allFlats': 'All flats',
    'dashboard.selectFlatFirst': 'Select flat first.',
    'dashboard.noDataForFlat': 'No data available for the flat.',
    'dashboard.otherExpense': 'Other Expense',
    'dashboard.unknownMonth': 'Unknown',
    'dashboard.house': 'House',
    'dashboard.flat': 'Flat',
    'dashboard.month': 'Month',
    'dashboard.amount': 'Amount',
    'dashboard.totalRenter': 'Total Renter',
    'dashboard.availableRenter': 'Available Renter',
    'dashboard.availableFlats': 'Available Flats',

    'report.yearlyTitle': 'Yearly Collection/Expense Report',
    'report.pdf': 'PDF',
    'report.flatInformation': 'Flat Information',
    'report.loading': 'Loading report...',
    'report.noDataForFlat': 'No data available for the flat.',
    'report.collectionDetails': 'Collection Details',
    'report.expenseDetails': 'Expense Details',
    'report.monthName': 'Month Name',
    'report.renter': 'Renter',
    'report.paymentDate': 'Payment Date',
    'report.flatRent': 'Flat Rent',
    'report.gasBill': 'Gas Bill',
    'report.electricBill': 'Electric Bill',
    'report.waterBill': 'Water Bill',
    'report.serviceChargeOther': 'Service Charge + Other',
    'report.adjustFromAdvance': 'Adjust From Advance',
    'report.totalAmount': 'Total Amount',
    'report.finalTotal': 'Final Total',
    'report.noCollectionData': 'No collection data found.',
    'report.expenseDate': 'Expense Date',
    'report.expenseHead': 'Expense Head',
    'report.amount': 'Amount',
    'report.noExpenseData': 'No expense data found.',
    'report.overallTotals': 'Overall Totals',
    'report.collection': 'Collection',
    'report.expense': 'Expense',
    'report.netCollectionMinusExpense': 'Net (Collection - Expense)',
    'report.rentOnlyTotals': 'Rent Only Totals',
    'report.totalFlatRent': 'Total Flat Rent',
    'report.totalFlatRentInfo': 'Show total flat rent calculation details',
    'report.netRentMinusExpense': 'Net (Rent - Expense)',
    'report.generatedOn': 'Generated On',
    'report.generatedBy': 'Generated By',
    'report.totalFlatRentCalculation': 'Total Flat Rent Calculation',
    'report.totalFlatRentFormula': 'Total Flat Rent = Flat Rent -',
    'report.houseNo': 'House No',
    'report.address': 'Address',
    'report.flat': 'Flat',
    'report.floor': 'Floor',
    'report.house': 'House',
    'report.month': 'Month',
    'report.payDate': 'Pay Date',
    'report.rent': 'Rent',
    'report.gas': 'Gas',
    'report.elec': 'Elec',
    'report.water': 'Water',
    'report.service': 'Service',
    'report.total': 'Total',
    'report.collectionDetailsCont': 'Collection Details (cont.)',
    'report.expenseDetailsCont': 'Expense Details (cont.)',
    'report.developedBy': 'Developed by',

    'signIn.title': 'Sign In',
    'signIn.emailPlaceholder': 'Type Email',
    'signIn.passwordPlaceholder': 'Type Password',
    'signIn.rememberMe': 'Remember me',
    'signIn.forgotPassword': 'Forgot Password?',
    'signIn.error.invalidCredentials': 'Username or password is wrong.',
    'signIn.submit': 'Sign In',
    'signIn.processing': 'Processing...',
    'signIn.newTo': 'New to HTally?',
    'signIn.signUp': 'Sign Up',
    'signIn.illustrationAlt': 'Sign in illustration',
    'signIn.forgot.title': 'Reset Password',
    'signIn.forgot.copy': 'Send an OTP to your email, verify it, and set a new password.',
    'signIn.forgot.email': 'Email',
    'signIn.forgot.emailPlaceholder': 'Type email',
    'signIn.forgot.sendOtp': 'Send OTP',
    'signIn.forgot.resendOtp': 'Resend OTP',
    'signIn.forgot.sending': 'Sending...',
    'signIn.forgot.otp': 'OTP',
    'signIn.forgot.otpPlaceholder': 'Type OTP',
    'signIn.forgot.otpExpiresIn': 'OTP expires in',
    'signIn.forgot.otpExpired': 'OTP expired. Resend OTP.',
    'signIn.forgot.newPassword': 'New Password',
    'signIn.forgot.newPasswordPlaceholder': 'Type new password',
    'signIn.forgot.confirmPassword': 'Retype password',
    'signIn.forgot.confirmPasswordPlaceholder': 'Retype password',
    'signIn.forgot.submit': 'Submit & Update Password',
    'signIn.forgot.updating': 'Updating...',

    'signUp.title': 'Sign Up',
    'signUp.stepProfile': '1. Profile',
    'signUp.stepCredentials': '2. Credentials',
    'signUp.stepOtp': '3. OTP',
    'signUp.next': 'Next',
    'signUp.passwordHint': 'Use at least 6 characters.',
    'signUp.sendOtp': 'Send OTP',
    'signUp.sendingOtp': 'Sending OTP...',
    'signUp.otpExpiresIn': 'OTP expires in',
    'signUp.otpExpired': 'OTP expired. Please go back and send OTP again.',
    'signUp.complete': 'Complete Sign Up',
    'signUp.creatingAccount': 'Creating Account...',
    'signUp.alreadyOnHtally': 'Already on HTally?',
    'signUp.signIn': 'Sign In',
    'signUp.imageModalTitle': 'Add Organization Logo',
    'signUp.imageModalHint': 'Optional: You can skip this step and upload later.',
    'signUp.imageRules': 'Allowed: .jpg, .jpeg, .png | Max: 1 file | Max size: 2MB',
    'signUp.logoPreviewAlt': 'Organization logo preview',
    'signUp.noFileSelected': 'No file selected.',
    'signUp.oneFileSelected': '1 file selected',
    'signUp.signupCompleted': 'Signup completed.'
    ,'entityList.empty': 'No data found.',
    'entityList.moreOptions': 'More options',

    'action.edit': 'Edit',
    'action.delete': 'Delete',
    'action.history': 'History',
    'action.paymentSlipDownload': 'Payment Slip Download',
    'action.paymentSlipPrint': 'Payment Slip Print',
    'action.receiptDownload': 'Receipt Download',
    'action.receiptPrint': 'Receipt Print',
    'action.sendReceipt': 'Send Receipt',

    'table.transactionNo': 'Transaction No',
    'table.name': 'Name',
    'table.mobile': 'Mobile',
    'table.email': 'Email',
'table.photoId': 'NID/Birth Reg No',
    'table.renter': 'Renter',
    'table.flat': 'Flat',
    'table.house': 'House',
    'table.paymentMonth': 'Payment Month',
    'table.paymentDate': 'Payment Date',
    'table.amount': 'Amount',
    'table.expenseHead': 'Expense Head',
    'table.expenseMonth': 'Expense Month',
    'table.expenseDate': 'Expense Date',
    'table.startDate': 'Start Date',
    'table.totalIncome': 'Total Income',
    'table.paymentStatus': 'Payment Status',
    'menu.SUBSCRIPTION_MENU': 'Subscription',
    'subscription.eyebrow': 'Flat based plans',
    'subscription.title': 'Choose a subscription plan',
    'subscription.subtitle': 'Start free with 5 flats. Upgrade by flat limit when you need more.',
    'subscription.loading': 'Loading subscription info...',
    'subscription.recommended': 'Recommended',
    'subscription.freePlan': 'Free forever',
    'subscription.currentPackage': 'Current Package',
    'subscription.yearlySave': 'Save 2 months bill',
    'subscription.flats': 'Active flats',
    'subscription.renters': 'active renters',
    'subscription.subusers': 'subusers',
    'subscription.storage': 'file storage',
    'subscription.packageExpireDate': 'Package Expire Date',
    'subscription.policyTitle': 'Policy summary',
    'subscription.policyFlat': 'Primary package limit is active flat count.',
    'subscription.policyStorage': 'Attachment and file upload storage stays under package storage limit.',
    'subscription.policyUpgrade': 'Users can create 5 flats free. From the 6th flat, they should take a subscription.',
    'subscription.contactTitle': 'Contact for subscription',
    'subscription.contactSubtitle': 'Use WhatsApp, mobile, or email for subscription activation or upgrade support. Payment methods will be added in the future.',
    'subscription.whatsapp': 'WhatsApp / Mobile',
    'subscription.email': 'Email'
  }
};
